export default __webpack_public_path__ + "8d0700cff57b438ab61d993a0e68b6f8.png";